import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"

dayjs.extend(utc)
dayjs.extend(timezone)

type IsValidDateFormat = (date?: string, format?: string) => boolean

export const isValidDateFormat: IsValidDateFormat = (date, format = "MM/DD/YYYY") => {
  if (!date) return false
  const formattedDate: string = dayjs(date, format).format(format)
  return date.length === format.length && formattedDate === date
}

export const dateFormatForReports = (date: string | Date | null) => {
  return date ? `${dayjs(date).utc().format("MMMM DD, YYYY") || ""} ${dayjs(date).utc().format("hh:mm A") || ""}` : ""
}

export const dateFormatForDisplay = (date: string | Date | null, timezone = "UTC") => {
  console.log(`date string: ${date}`)
  console.log(timezone)
  console.log(dayjs(date).tz(timezone).format("MMMM DD, YYYY"))
  console.log(dayjs(date).tz(timezone).format("hh:mm A"))
  return date ? `${dayjs(date).tz(timezone).format("MMMM DD, YYYY") || ""} ${dayjs(date).tz(timezone).format("hh:mm A") || ""}` : ""
}

export const isSameOrAfter = (date: Date, dateToCompare: Date) => {
  return dayjs(date).isSame(dateToCompare, "date") || dayjs(date).isAfter(dateToCompare, "date")
}
